// extracted by mini-css-extract-plugin
export default {"rating":"gK-z","numberOfStars":"hK-z","count":"iK-z","barGraphSpacing":"jK-z","barGraph":"kK-z"};